<template>
  <WarningDirectory
    :style="{ ...position, ...customStyle }"
    :class="[isEmpty(position) ? '' : 'absolute-el', allowTrigger ? 'allow-trigger' : '']"
    :dataList="earlyWarnDataList"
    :activeIndex="activeIndex"
    @read="onRead"
  ></WarningDirectory>
  <WarningDetail ref="$detailRef"></WarningDetail>
</template>

<script lang="ts" setup>
import { EarlyWarnData, EarlyWarnStoreData, EarlyWarnProps } from "./index.d"
import WarningDetail from "./components/WarningDetail.vue"
import WarningDirectory from "./components/WarningDirectory.vue"
import { isEmpty, merge, orderBy } from "lodash-es"
import { watch, ref, shallowRef, toRaw } from "vue"

interface MappingType {
  [key: string]: any
}

const props = withDefaults(defineProps<EarlyWarnProps>(), {})

const showDesc = props.options.showDesc
const allowTrigger = props.options.allowTrigger
const holdMinutes = props.options.holdMinutes * 60 * 1000
const dataMappingConfig = props.dataMapping
const detailFollowColor = props.options.detailFollowColor
const detailStyle = props.options.detailStyle
const contentStyle = props.options.detailContentStyle

const $detailRef = shallowRef()
const inValue = ref<number>(0)
const holdValue = ref<number>(0)
const activeIndex = ref<number>(-1)

const earlyWarnDataList = ref<EarlyWarnData[]>([])
const matchIndex = ref<number | null>(null)
const isHoldding = ref<boolean>(false)

/**
 * 根据区间配置，监测处理源数据
 * @param configList
 * @param sourceDataList
 */
// function detectSourceData(configList: any[], sourceDataList: EarlyWarnData[]): EarlyWarnData[] {
//   const gapNum = configList.length - sourceDataList.length
//   // 补录默认数据
//   const defaultEarlyWarn: EarlyWarnData = {
//     title: "预警标题",
//     summary: "预警概要",
//     detail: "预警方案",
//     level: 9,
//     color: "red",
//     sort: 9,
//   }

//   if (gapNum == 0) {
//     return sourceDataList
//   } else if (gapNum < 0) {
//     return sourceDataList.concat(new Array(gapNum).fill(defaultEarlyWarn))
//   } else {
//     return sourceDataList.splice(0, configList.length)
//   }
// }

/**
 *
 * @param data
 * @param style
 */
function triggerDetailRead(data: EarlyWarnData) {
  if (!showDesc || !data) return false
  const { title, detail: text, color } = toRaw(data)
  console.log("---color", color)
  let style = toRaw(detailStyle)
  if (detailFollowColor) {
    style.backgroundColor = color
  }
  console.log("triggerDetailRead", $detailRef, title, style)
  $detailRef.value.show(title, text, style, contentStyle)
}

/**
 * 点阅详情
 * @param index
 */
function onRead({ index, data }: { index: number; data: EarlyWarnData }) {
  // console.log('onRead', index, data);
  if (allowTrigger) {
    // const { action } = rangeSettingList[index];
    triggerDetailRead(data)
  }
}

const dataMappingAdapter = (data: MappingType[], config: any) => {
  return data.map(item => {
    const newItem: any = {}
    for (const key in config) {
      if (config[key] && item[config[key]]) {
        newItem[key] = item[config[key]]
      }
    }
    return newItem
  })
}

watch(
  () => props.storeData as EarlyWarnStoreData,
  storeData => {
    if (isEmpty(storeData)) return
    const { inNum = 0, holdNum = 0, cmsDataList = [] } = storeData
    if (isEmpty(cmsDataList)) return
    // console.log('early warning storeData', num, cmsDataList);
    // 数据转换
    let sourceDataList: EarlyWarnData[] = dataMappingAdapter(cmsDataList as MappingType[], dataMappingConfig) as EarlyWarnData[]
    // 数据排序
    if (props.options.sort) {
      const { fields, order } = props.options.sort
      sourceDataList = orderBy(sourceDataList, fields, order)
    }
    inValue.value = inNum
    holdValue.value = holdNum
    // earlyWarnDataList.value = detectSourceData(rangeSettingList, sourceDataList)
    earlyWarnDataList.value = sourceDataList
    // 进行数值匹配
    const matchRangeSetting = new Function(...["inNum", "holdNum", "dataList"], props.matchRangeSetting).bind(this)

    const index = matchRangeSetting(inValue.value, holdValue.value, sourceDataList)

    if (props.options.hightlightInfo) {
      activeIndex.value = index
    }

    const matchEarlyWarnData = earlyWarnDataList.value[index]
    // 是否触发预警判断：matchIndex变化
    if (index !== matchIndex.value) {
      matchIndex.value = index
      // matchStyleConfig.value = action;
      isHoldding.value = true
      setTimeout(() => {
        isHoldding.value = false
      }, holdMinutes)
      triggerDetailRead(matchEarlyWarnData)
    } else {
      if (!isHoldding.value) {
        matchIndex.value = index
        // matchStyleConfig.value = action;
        isHoldding.value = true
        setTimeout(() => {
          isHoldding.value = false
        }, holdMinutes)
        triggerDetailRead(matchEarlyWarnData)
      }
    }
  },
  {
    immediate: true,
    deep: true,
  },
)
</script>
